// @flow

import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";

import http from "@http";
import actionCreators from "@modules/shared/actionCreator";
import { GetServiceSectionStatuses } from "@modules/shared/constants/actions";

type ShiftPatternsRequest = $Exact<{
  clientId: string,
}>;

export function* onGetServiceSectionStatuses({
  payload,
}: Action<ShiftPatternsRequest>): Generator<*, void, Object> {
  if (!payload || !payload.clientId) {
    throw Error("Invalid payload provided");
  }

  try {
    const response = yield call(
      http.get,
      `/api/v1/service-admin/client/${payload.clientId}/service-config/service-section-status`,
    );

    yield put(actionCreators.GetServiceSectionStatusesSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetServiceSectionStatusesError(e.response));
  }
}

export function* ShiftPatternSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetServiceSectionStatuses, onGetServiceSectionStatuses)]);
}

export default ShiftPatternSagas;
